// This is the DOM element that is assumed to exist
// where the SearchMask component will be mounted.
export const target = document.getElementById('search-mask-component');

// SearchMask is considered to be isolated when the target element contains this attribute
export const isIsolated = target !== null && target.getAttribute('data-isolated') !== null;
